import { render, staticRenderFns } from "./receivablesInfo.vue?vue&type=template&id=ad801bfe"
import script from "./receivablesInfo.vue?vue&type=script&lang=js"
export * from "./receivablesInfo.vue?vue&type=script&lang=js"
import style0 from "./receivablesInfo.vue?vue&type=style&index=0&id=ad801bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports